<template>
<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
  <!--=====================================
     Page Header Details Section
  ======================================-->
  <section class="pt-32 max-md:pb-20 md:py-44 lg:pt-[200px] relative overflow-hidden">
    <!-- Gradient Background Wrapper -->
    <div id="hero-gradient-wrapper" class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] sm:scale-[0.1] bg-blend-multiply md:scale-75">
      <img src="images/hero-gradient-background.png" alt="hero-gradient-background" id="hero-gradient" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[45%]" />
    </div>

    <!-- Hero Content Container -->
    <div class="container reveal-me">
      <div class="text-center">
        <!-- Badge Component -->
        <div class="rv-badge mb-4 lg:mb-10">
          <span class="rv-badge-text">Services Details</span>
        </div>

        <!-- Hero Title -->
        <h1 class="mb-5 lg:mb-8">Development</h1>

        <!-- Hero Description -->
        <p class="max-md:max-w-[650px]">
          Transform your vision into high-performance digital experiences with our expert development services. We specialize in:<br><br>
        </p>
      </div>
    </div>
  </section>

  <!--=====================================
     Services Details Section
  ======================================-->
  <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
    <div class="max-w-[1440px] mx-auto px-8 md:px-20">
      <div class="flex flex-col gap-8 lg:flex-row justify-start">
        <!-- Sticky Table of Contents -->
        <aside class="min-w-[275px] flex-1">
          <div class="sticky top-28">
            <div class="reveal-me">
              <h3 class="max-md:text-[40px] md:text-[32px]">Table of contents</h3>
              <ul class="mt-4 sm:mt-7 md:mt-10 [&>*:not(:last-child)]:mb-2 md:[&>*:not(:last-child)]:mb-5">
                <li>
                  <a href="#service-overview" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Service overview</a>
                </li>
                <li>
                  <a href="#our-service-includes" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Our service includes</a>
                </li>
                <li>
                  <a href="#why-choose" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Why Choose Us</a>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        <!-- Main Content -->
        <article class="project-details-body">
          <div class="reveal-me">
            <h3 id="service-overview">Service overview</h3>
            <p>
              At Neue Media, our development team turns ideas into robust digital solutions. We focus on crafting high-performance websites, mobile apps, and custom software that not only look great but also perform seamlessly.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="our-service-includes">Our service includes</h3>
            <p>
              In-Depth Technical Consultation: We work with you to understand your business needs and technical requirements.<br><br>
              <strong>Web Development:</strong> Building custom websites, eCommerce platforms, and CMS solutions tailored to your brand.<br><br>
              <strong>Mobile App Development:</strong> Crafting native and cross-platform applications for iOS and Android.<br><br>
              <strong>Custom Software:</strong> Developing backend systems, API integrations, and automation tools that streamline your operations.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="why-choose">Why Choose Us</h3>
            <p>
              Expertise and Innovation: Our experienced developers use cutting-edge technologies to build scalable and secure solutions.<br><br>
              Tailored Solutions: We customize our approach to meet your unique business challenges.<br><br>
              Seamless Collaboration: We ensure clear communication and a transparent process from concept to launch.<br><br>
              End-to-End Service: From initial planning to final deployment, we handle every aspect of your digital transformation.<br><br>
              Results-Driven Approach: Our focus is on delivering measurable outcomes that boost efficiency and drive growth.
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!--=====================================
     CTA Section
  ======================================-->
  <section class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative">
    <div class="container">
      <!-- CTA Heading -->
      <h2 class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]">
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block">
          We’ve Got Answers
        </span>
      </h2>

      <ul class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none">
        <!-- Primary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"></li>
        <!-- Secondary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto">
          <router-link to="/contact" class="rv-button rv-button-primary block md:inline-block">
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>

</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>

</template>
<script>
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  name: 'DevelopmentPage',
  components: {
    FooterComponent,
  }
}
</script>